

export default function HeroCard3() {

      const ICONS = {
    center: "https://cdn-icons-png.flaticon.com/512/5968/5968853.png",
    calendar: "https://cdn-icons-png.flaticon.com/512/747/747310.png",
    whatsapp: "https://cdn-icons-png.flaticon.com/512/733/733585.png",
    payments: "https://cdn-icons-png.flaticon.com/512/891/891462.png",
    zoom: "https://cdn-icons-png.flaticon.com/512/732/732200.png",
    zapier: "https://cdn-icons-png.flaticon.com/512/5968/5968988.png",
    wix: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    dev: "https://cdn-icons-png.flaticon.com/512/9068/9068641.png",
    circle: "https://cdn-icons-png.flaticon.com/512/1827/1827504.png",
  };

  return (<>
 <section className="ex-hero">
      <div className="ex-card">
        {/* LEFT */}
        <div className="ex-left">
          <h1 className="ex-title">
            The <span className="grad1">Entrepreneurs</span>
            <br />
            Super App that <span className="grad2">maximizes</span>
            <br />
            profits.
          </h1>

          <p className="ex-desc">
            With EXLY, you can maximize your income and save on expenses — all in one place.
          </p>

          <div className="ex-stats">
            <div className="stat">💪 100,000+ creators strong</div>
            <div className="stat">🤝 1 crore+ courses sold</div>
          </div>

          <button className="ex-btn">Book a Demo!</button>
        </div>

        {/* RIGHT – MULTI-LAYER ORBIT + SVG TRAILS */}
        <div className="ex-right">
          <div className="orbit-c3-container">

            {/* glass center */}
            <div className="glass-circle" />
            <img src={ICONS.center} className="logo center" alt="center" />

            {/* --- INNER RING (fast clockwise) --- */}
            <svg className="trail trail-inner" viewBox="0 0 450 450" preserveAspectRatio="none">
              <defs>
                <linearGradient id="gInner" x1="0" x2="1">
                  <stop offset="0%" stopColor="#8a6bff" stopOpacity="0.0" />
                  <stop offset="30%" stopColor="#8a6bff" stopOpacity="0.25" />
                  <stop offset="100%" stopColor="#8a6bff" stopOpacity="0.06" />
                </linearGradient>
                <filter id="blurSmall"><feGaussianBlur stdDeviation="6" /></filter>
              </defs>
              <circle cx="225" cy="225" r="120" fill="none" stroke="url(#gInner)"
                strokeWidth="8" strokeLinecap="round" filter="url(#blurSmall)"
                strokeDasharray="754" strokeDashoffset="150"></circle>
            </svg>

            <div className="orbit-c3 orbit-c3-inner">
              <img src={ICONS.calendar} className="logo small" alt="" />
            </div>

            <div className="orbit-c3 orbit-c3-inner delay2">
              <img src={ICONS.dev} className="logo small" alt="" />
            </div>

            {/* --- MIDDLE RING (slower counterclockwise) --- */}
            <svg className="trail trail-middle" viewBox="0 0 450 450" preserveAspectRatio="none">
              <defs>
                <linearGradient id="gMid" x1="0" x2="1">
                  <stop offset="0%" stopColor="#00c786" stopOpacity="0.0" />
                  <stop offset="35%" stopColor="#00c786" stopOpacity="0.28" />
                  <stop offset="100%" stopColor="#00c786" stopOpacity="0.07" />
                </linearGradient>
                <filter id="blurMid"><feGaussianBlur stdDeviation="9" /></filter>
              </defs>
              <circle cx="225" cy="225" r="165" fill="none" stroke="url(#gMid)"
                strokeWidth="9" strokeLinecap="round" filter="url(#blurMid)"
                strokeDasharray="1036" strokeDashoffset="260"></circle>
            </svg>

            <div className="orbit-c3 orbit-c3-middle">
              <img src={ICONS.whatsapp} className="logo small" alt="" />
            </div>

            <div className="orbit-c3 orbit-c3-middle delay3">
              <img src={ICONS.wix} className="logo small" alt="" />
            </div>

            {/* --- OUTER RING (slow clockwise) --- */}
            <svg className="trail trail-outer" viewBox="0 0 450 450" preserveAspectRatio="none">
              <defs>
                <linearGradient id="gOuter" x1="0" x2="1">
                  <stop offset="0%" stopColor="#ff7a7a" stopOpacity="0.0" />
                  <stop offset="30%" stopColor="#ff7a7a" stopOpacity="0.22" />
                  <stop offset="100%" stopColor="#ff7a7a" stopOpacity="0.08" />
                </linearGradient>
                <filter id="blurOuter"><feGaussianBlur stdDeviation="12" /></filter>
              </defs>
              <circle cx="225" cy="225" r="200" fill="none" stroke="url(#gOuter)"
                strokeWidth="10" strokeLinecap="round" filter="url(#blurOuter)"
                strokeDasharray="1256" strokeDashoffset="380"></circle>
            </svg>

            <div className="orbit-c3 orbit-c3-outer">
              <img src={ICONS.zapier} className="logo small" alt="" />
            </div>

            <div className="orbit-c3 orbit-c3-outer delay4">
              <img src={ICONS.payments} className="logo small" alt="" />
            </div>

            <div className="orbit-c3 orbit-c3-outer delay5">
              <img src={ICONS.circle} className="logo small" alt="" />
            </div>

          </div>
        </div>
      </div>
    </section><style>{`/* ---------- Base Layout (same as previous card) ---------- */
.ex-hero {
  width: 100%;
  padding: 60px 0;
  
  display: flex;
  justify-content: center;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

.ex-card {
  width: 90%;
  max-width: 1400px;
  background: white;
  padding: 60px 80px;
  border-radius: 25px;
  display: flex;
  gap: 40px;
  align-items: center;
  border: 3px solid #ecebff;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
}

.ex-left { flex: 1.2; }
.ex-right { flex: 1; display:flex; justify-content:center; align-items:center; }

/* Text */
.grad1 { background: linear-gradient(90deg,#5c27fe,#9a59ff); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }
.grad2 { background: linear-gradient(90deg,#0aaf78,#0cc26a); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }

.ex-title { font-size:48px; font-weight:800; line-height:1.2; margin-bottom:20px; color:#1e1e1e; }
.ex-desc { font-size:18px; margin-bottom:30px; width:85%; color:#555; }
.ex-stats { display:flex; gap:25px; margin-bottom:25px; }
.stat { background:#f4f1ff; padding:10px 18px; border-radius:12px; font-size:16px; display:flex; align-items:center; }
.ex-btn { background:#4c3aff; color:white; padding:15px 40px; border-radius:12px; font-size:18px; border:none; cursor:pointer; }

/* ---------- Orbit Container ---------- */
.orbit-c3-container {
  position: relative;
  width: 450px;
  height: 450px;
}

/* Glass center */
.glass-circle {
  position: absolute;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  backdrop-filter: blur(18px);
  background: linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.14));
  border: 1.5px solid rgba(255,255,255,0.45);
  box-shadow: 0 10px 35px rgba(0,0,0,0.12);
  z-index: 8;
}

/* center logo */
.logo.center {
  position: absolute;
  width: 100px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  filter: drop-shadow(0 6px 20px rgba(0,0,0,0.12));
}

/* ---------- Trails (SVG) ---------- */
.trail {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 3;
  pointer-events: none;
}

/* Slight animation on dashoffset to create movement along stroke */
.trail circle {
  transform-origin: 225px 225px; /* center of viewBox */
  transition: stroke-dashoffset 0.6s linear;
  /* subtle animated flow */
  animation: dashFlow 6s linear infinite;
}

/* remove pointer events from logos' underlying svg */
.trail-inner { z-index: 3; }
.trail-middle { z-index: 2; }
.trail-outer { z-index: 1; }

/* ---------- Orbit element containers (position logos on top of trails) ---------- */
.orbit-c3 {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0; top: 0;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  transform-origin: center;
}

.orbit-c3-inner { animation-name: rotateInner; animation-duration: 12s; z-index: 6; }
.orbit-c3-middle { animation-name: rotateMiddle; animation-duration: 18s; z-index: 5; }
.orbit-c3-outer { animation-name: rotateOuter; animation-duration: 26s; z-index: 4; }

/* delays to spread logos */
.delay2 { animation-delay: -4s; }
.delay3 { animation-delay: -7s; }
.delay4 { animation-delay: -10s; }
.delay5 { animation-delay: -14s; }

/* logo inside orbit-c3 placed on top of circle (top position) */
.logo.small {
  width: 64px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -32px; /* sits slightly outside the circle */
  transition: transform 0.28s ease, filter 0.28s ease;
  z-index: 9;
}

/* hover */
.logo.small:hover {
  transform: translateX(-50%) scale(1.24);
  filter: brightness(1.25) drop-shadow(0 6px 18px rgba(110, 90, 255, 0.45));
}

/* ---------- Rotation Keyframes ---------- */
@keyframes rotateInner {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes rotateMiddle {
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
}

@keyframes rotateOuter {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* animate stroke dash to simulate moving glow */
@keyframes dashFlow {
  0% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: -200; }
}

/* responsive */
@media (max-width: 992px) {
  .ex-card { flex-direction: column; padding: 50px 30px; }
  .ex-desc { width: 100%; text-align: center; }
  .orbit-c3-container { width: 340px; height: 340px; }
}

`}</style>
  </>);
}
